// src/features/encounter/encounterSlice.ts
//       // ❷ 환자 정보 수정 API 호출
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import { PharmaComplexSerializer } from "@/types/pharma"
import { fetchPharmaComplex } from "@core/api/pharmaComplexApi"

interface PharmaPayload {
  pharmas: PharmaComplexSerializer[] | null
  loading: boolean
  error: string | null
}

const initialState: PharmaPayload = {
  pharmas: null,
  loading: false,
  error: null,
}

const pharmaComplexSlice = createSlice({
  name: "suga",
  initialState,
  reducers: {
    clearPharmas(state) {
      state.pharmas = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: builder => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchPharmaComplex.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPharmaComplex.fulfilled, (state, action) => {
        state.loading = false
        state.pharmas = action.payload
        // console.debug("수가 목록", state.sugas)
      })
      .addCase(fetchPharmaComplex.rejected, (state, action) => {
        state.loading = false
        state.pharmas = null
        state.error = (action.payload as string) || action.error.message || "오류 "
      })
  },
})

export const { clearPharmas, setLoading, setError } = pharmaComplexSlice.actions

export default pharmaComplexSlice.reducer
